import { render, staticRenderFns } from "./LookDetail.vue?vue&type=template&id=d1453150&scoped=true&"
import script from "./LookDetail.vue?vue&type=script&lang=js&"
export * from "./LookDetail.vue?vue&type=script&lang=js&"
import style0 from "./LookDetail.vue?vue&type=style&index=0&id=d1453150&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1453150",
  null
  
)

export default component.exports